// Taken from https://github.com/tinymce/tinymce/blob/develop/modules/oxide/src/less/skins/content/dark/content.less

export default `
/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 */

//
// Place your HTML here
//

html {
  height: 100%;
}

body {
  color: #dfe0e4;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  height: calc(100% - 2rem);
  line-height: 1.4;
  margin: 1rem;
}

a {
  color: #4099ff;
}

table {
  border-collapse: collapse;
}

table th,
table td {
  border: 1px solid #6d737b;
  padding: .4rem;
}

figure {
  display: table;
  margin: 1rem auto;
}

figure figcaption {
  color: #8a8f97;
  display: block;
  margin-top: .25rem;
  text-align: center;
}

hr {
  border-color: #6d737b;
  border-style: solid;
  border-width: 1px 0 0 0;
}

code {
  background-color: #6d737b;
  border-radius: 3px;
  padding: .1rem .2rem;
}

/* Make text in selected cells in tables dark and readable */
td[data-mce-selected],
th[data-mce-selected] {
  color: #333;
}

.mce-content-body:not([dir=rtl]) {
  blockquote {
    border-left: 2px solid #6d737b;
    margin-left: 1.5rem;
    padding-left: 1rem;
  }
}

[data-tooltip] {
  position: relative;
}

[data-tooltip]:hover:before {
  display: inline-block;
}

[data-tooltip]:before {
  content:attr(data-tooltip);
  position:absolute;
  top: 20px;
  left: 0;
  text-align: center;
  background: #fff;
  color:#000;
  display: none;
  padding: 5px 10px;
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 6px;
  z-index: 2;
}

// RTL
.mce-content-body[dir=rtl] {
  blockquote {
    border-right: 2px solid #6d737b;
    margin-right: 1.5rem;
    padding-right: 1rem;
  }
}
`;
